import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,      // 5 minutes — data stays fresh
      gcTime: 1000 * 60 * 10,         // 10 minutes — cache garbage collection
      retry: 2,                        // retry failed requests twice
      refetchOnWindowFocus: false,     // don't refetch on tab switch
      refetchOnReconnect: true         // refetch when internet reconnects
    },
    mutations: {
      retry: 1
    }
  }
});

export default queryClient;
